import { ContentsSourceEnum } from '../constants/createSendContents';
import { TMarketplaceBucketItem } from '../types/bucket';
import { ICampaign } from '../types/campaigns';
import { TPygOption } from '../types/createSendContents';
import { getMarketplaceProductId } from './marketplacePayload';

/**
 * Kits and picks as one ordered list of Pick-your-gift options. They persist in separate arrays,
 * so the interleaved order lives beside them as a list of ids. Anything not named in `order` keeps
 * append order at the end — kits then picks — so the rail is right before any drag has happened.
 */
export const orderPygOptions = (kits: ICampaign[], picks: TMarketplaceBucketItem[], order: string[]): TPygOption[] => {
  const options: TPygOption[] = [
    ...kits.map((kit): TPygOption => ({ kind: ContentsSourceEnum.IeCatalog, id: kit.box_id, kit })),
    ...picks.map((item): TPygOption => ({ kind: ContentsSourceEnum.Marketplace, id: item.item_id, item })),
  ];

  // Guard the persisted value: `contents` has no normalizing persist transform, so a corrupt
  // `pygOptionOrder` would otherwise throw here and white-screen the Contents step.
  const rank = new Map((Array.isArray(order) ? order : []).map((id, index) => [id, index]));

  // Stable: equal ranks (both unordered) keep the append order above.
  return options
    .map((option, index) => ({ option, index }))
    .sort((a, b) => {
      const rankA = rank.get(a.option.id) ?? Number.MAX_SAFE_INTEGER;
      const rankB = rank.get(b.option.id) ?? Number.MAX_SAFE_INTEGER;

      return rankA === rankB ? a.index - b.index : rankA - rankB;
    })
    .map(({ option }) => option);
};

export const getPygOptionWireId = (option: TPygOption): string =>
  option.kind === ContentsSourceEnum.IeCatalog ? option.kit.box_id : getMarketplaceProductId(option.item);

export const orderPygOptionIds = (kits: ICampaign[], picks: TMarketplaceBucketItem[], order: string[]): string[] =>
  orderPygOptions(kits, picks, order).map(getPygOptionWireId);
